module.exports = __webpack_public_path__ + "media/components/util/logos/vecteezy-logo--mountain-54ab23ad3a8fc896332e955c5c3185c2.jpg";